import angular from 'angular';
import template from './template.html';
import './style.scss';
import { ENGAGEMENT_AFTER_RATING, IMMEDIATE_ENGAGEMENT } from '../../../../constants/positionServiceType';

export class PositionTableFilterToolbar {
    tableId = '';

    dateOptions = [{
        label: 'ALL',
        value: 'ALL',
    }, {
        label: 'LAST_WEEK',
        value: 'LAST_WEEK',
    }, {
        label: '2_WEEKS_AGO',
        value: '2_WEEKS_AGO',
    }, {
        label: '30_DAYS',
        value: '30_DAYS',
    }, {
        label: '60_DAYS',
        value: '60_DAYS',
    }, {
        label: '120_DAYS',
        value: '120_DAYS',
    }];

    projectStatusOptions = [{
        label: 'OPEN_PROJECTS',
        value: 'Active',
    }, {
        label: 'CLOSED_PROJECTS',
        value: 'Inactive',
    }];

    positionServiceTypeOptions = [
        {
            label: 'JOB_VIEW_SERVICE_TYPE_STATUS_ENGAGEMENT_AFTER_RATING',
            value: ENGAGEMENT_AFTER_RATING,
        },
        {
            label: 'JOB_VIEW_SERVICE_TYPE_STATUS_IMMEDIATE_ENGAGEMENT',
            value: IMMEDIATE_ENGAGEMENT,
        },
    ];

    modeOptions = [{
        label: 'TALENT_EXPERT_MODE',
        value: 'TALENT_EXPERT_MODE',
    }, {
        label: 'EMPLOYER_MODE',
        value: 'EMPLOYER_MODE',
    }];

    filterState = null;

    /* @ngInject */
    constructor($sessionStorage, $localStorage, $state, $scope) {
        this.$sessionStorage = $sessionStorage;
        this.$localStorage = $localStorage;
        this.$state = $state;
        this.$scope = $scope;
    }

    $onInit() {
        this.$scope.searchFilter = { value: '' };
        const current = this.$state.current;
        const isJobsView = (current.name === 'talenya.jobs');

        if (isJobsView) {
            this.modeOptions.push({
                label: 'JOB_SUMMARY_MODE',
                value: 'JOB_SUMMARY_MODE',
            });
        }
        this.$scope
            .$watch(scope => scope.searchFilter.value, (newValue) => {
                this.onSearchValueChange(newValue);
            });
    }

    get storage() {
        return this.$localStorage;
    }

    onSearchValueChange(searchValue) {
        this.changeFilterState('searchValue', searchValue);
    }

    onDateOptionChange({ value }) {
        this.changeFilterState('dateValue', value);
    }

    onProjectStatusChange({ value }) {
        this.changeFilterState('projectStatusValue', value);
    }

    onPositionServiceTypeChange({ value }) {
        this.changeFilterState('positionServiceTypeValue', value);
    }

    onShowJobProgressStateChange(value) {
        this.changeFilterState('showJobProgressState', value);
    }

    onModeOptionChange({ value }) {
        this.changeFilterState('modeValue', value);
    }

    changeFilterState(filterCriteriaName, filterCriteriaValue) {
        const filterState = this.filterState;

        filterState[filterCriteriaName] = filterCriteriaValue;

        this.saveFilterState(filterState);
        this.onFilterStateChange({ filterState });
    }

    saveFilterState(filterState) {
        const tableState = this.storage[this.tableId];

        if (tableState) {
            tableState.filterState = filterState;
        } else {
            this.storage[this.tableId] = { filterState };
        }
    }
}

export const PositionTableFilterToolbarConfiguration = {
    template,
    bindings: {
        tableId: '@',
        filterState: '<',
        searchPlaceholderKey: '<',
        onFilterStateChange: '&',
    },
    controller: PositionTableFilterToolbar,
    controllerAs: 'positionTableFilterToolbarCtrl',
};

angular.module('TALENYA-FE').component('positionTableFilterToolbar', PositionTableFilterToolbarConfiguration);
